export default [
  {
    path: "property",
    name: "property",
    component: () => import("../pages/platformReport/index.vue"),
    children: [
      //通用
      {
        path: "material.html",
        name: "MaterialManagement",
        component: () => import("../pages/material-management/materialIndex.vue"),
        meta: {
          title: "素材管理",
        },
      },
      {
        path: "tag.html",
        name: "TagManagement",
        component: () => import("../pages/property/tag-management/index.vue"),
        meta: {
          title: "标签管理",
        },
      },
      {
        path: "type_manager.html",
        name: "tagTypeManagement",
        component: () => import("../pages/property/tag-type-management/index.vue"),
        meta: {
          title: "类型管理",
        },
      },
      {
        path: "tagname_manager.html",
        name: "TagNameManagement",
        component: () => import("../pages/property/tagname-parse-management/index.vue"),
        meta: {
          title: "命名解析管理",
        },
      },
      {
        path: "youtube_upload.html",
        name: "youtubeUpload",
        component: () => import("../pages/property/youtube-upload/index.vue"),
        meta: {
          title: "YouTube上传管理",
        },
      },
      {
        path: "youtube_user.html",
        name: "youtubeUser",
        component: () => import("../pages/property/youtube-user/index.vue"),
        meta: {
          title: "YouTube用户管理",
        },
      },
      //头条
      {
        path: "toutiao_convert_html",
        name: "toutiao_convert",
        component: () => import("../pages/platformReport/toutiao/convert"),
        meta: {
          title: "头条转化管理",
        },
      },
      {
        path: "audience_html",
        name: "toutiao_audience",
        component: () => import("../pages/platformReport/toutiao/customeRqb"),
        meta: {
          title: "头条人群包",
        },
      },
      {
        path: "target_html",
        name: "toutiao_target",
        component: () => import("../pages/platformReport/toutiao/directionalPkg"),
        meta: {
          title: "头条定向包",
        },
      },
      {
        path: "ad_template_html",
        name: "toutiao_template",
        component: () => import("../pages/platformReport/toutiao/adTemplate"),
        meta: {
          title: "头条广告模板",
        },
      },
      {
        path: "event_manager.html",
        name: "event_manager",
        component: () => import("../pages/platformReport/toutiao/eventManager"),
        meta: {
          title: "头条事件管理",
        },
      },
      {
        path: "budget.html",
        name: "budget",
        component: () => import("../pages/platformReport/toutiao/budget"),
        meta: {
          title: "头条预算包",
        },
      },
      {
        path: "title.html",
        name: "title",
        component: () => import("../pages/platformReport/toutiao/title"),
        meta: {
          title: "头条标题包",
        },
      },
    ],
  },
  {
    path: "kuaishou",
    name: "kuaishou",
    component: () => import("../pages/platformReport/index.vue"),
    children: [
      //快手
      {
        path: "convert.html",
        name: "convert",
        component: () => import("../pages/platformReport/kuaishou/convert"),
        meta: {
          title: "快手转换管理",
        },
      },
      {
        path: "audience.html",
        name: "audience",
        component: () => import("../pages/platformReport/kuaishou/customeRqb"),
        meta: {
          title: "快手人群包",
        },
      },
      {
        path: "target.html",
        name: "target",
        component: () => import("../pages/platformReport/kuaishou/directionalPkg"),
        meta: {
          title: "快手定向包",
        },
      },
      {
        path: "ad_temp.html",
        name: "template",
        component: () => import("../pages/platformReport/kuaishou/adTemplate"),
        meta: {
          title: "快手广告模板",
        },
      },
    ],
  },
  {
    path: "gdt",
    name: "gdt",
    component: () => import("../pages/platformReport/index.vue"),
    children: [
      //广点通
      {
        path: "conver.html",
        name: "conver",
        component: () => import("../pages/platformReport/gdt/convert"),
        meta: {
          title: "广点通转换管理",
        },
      },
      {
        path: "ad_temp.html",
        name: "adTemplate",
        component: () => import("../pages/platformReport/gdt/adTemplate"),
        meta: {
          title: "广点通广告模板",
        },
      },
    ],
  },
  {
    path: "google",
    name: "google",
    component: () => import("../pages/platformReport/index.vue"),
    children: [
      //google
      {
        path: "convert.html",
        name: "convert",
        component: () => import("../pages/platformReport/google/convert"),
        meta: {
          title: "Google转化管理",
        },
      },
      {
        path: "geo.html",
        name: "geo",
        component: () => import("../pages/platformReport/google/geo"),
        meta: {
          title: "Google地区组",
        },
      },
      {
        path: "creative.html",
        name: "creative",
        component: () => import("../pages/platformReport/google/creative"),
        meta: {
          title: "Google创意组",
        },
      },
      {
        path: "title.html",
        name: "title",
        component: () => import("../pages/platformReport/google/title"),
        meta: {
          title: "Google标题包",
        },
      },
      {
        path: "desc.html",
        name: "desc",
        component: () => import("../pages/platformReport/google/desc"),
        meta: {
          title: "Google描述包",
        },
      },
      {
        path: "ad_template.html",
        name: "ad_template",
        component: () => import("../pages/platformReport/google/adTemplate"),
        meta: {
          title: "Google广告模板",
        },
      },
    ],
  },
];
